namespace('compass.hotel');
compass.require('compass.hotel.SimplifiedHotelFilterDatePicker');
compass.require('compass.hotel.VoiceTranscriptionWidget');

compass.hotel.SimplifiedHotelFilterWidget = compass.defineWidget(function SimplifiedHotelFilterWidget(options) {
	var me = this;
	var settings = options;
	var $j = jQuery;
	var d = $j.dom;

	// note: for stability reasons, before accessing `currFilter` directly, please
	// consider if `cloneCurrentFilterObject()` will work just as well instead
	var currFilter = {}; 
	var firstQuerySearch = true;
	var startWithClearButtonActive = false;

	// sub-widget references
	var datePicker;
	var additionalFilters;
	var clearAllFiltersButton;
	var promotions = ['All Exclusive Promotions'];
	settings.hotels.map(function(hotel) {
		hotel.promotions.map(function(promo) {
			if (!promotions.includes(promo.type) && settings.onPeakPromotionTypes.includes(promo.type) && promo.type != 'Other') promotions.push(promo.type); 
		});
	});
	var ecoFilterEnabled = false;
	var selectedPromos = '';
	var relativePromotionsFilterContainer;
	var backerElement;
	var previousFilterObjects = [];
	var selectedPromoText;

	me.filtersLocked = false;
	me.occupancy = undefined;

	// update lock variable & add/remove 'disabled' class on all lockable filters
	me.updateFilterLock = function(lock) {
		me.filtersLocked = !!lock;
		var targetClasses = [
			'.hotelChainFilter',
			'.additionalFilterButton',
			'.sortByFilter'
		];
		if (lock) {
			for (var index in targetClasses) {
				me.find(targetClasses[index]).addClass('disabled');
			}
		} else {
			me.find('.checkInOutDatesWarning').remove();
			for (var index in targetClasses) {
				me.find(targetClasses[index]).removeClass('disabled');
			}
		}
	};

	// Generator for unique element IDs. Used in conjunction with `updateFilter()`
	me.generateFilterKey = (function() {
		var n = 0;
		return function() {
			return 'filter_key_' + (++n);
		};
	})();

	me.unsetFilter = function(key) {
		delete currFilter[key];
		me.updatePromoSelectText();

		var input = me.find('input.' + key);
		var type = input.attr('type');
		if(type == 'text' || type == 'textarea') {
			input.val('');
		} else if(type == 'checkbox') {
			input.removeAttr('checked');
		}
	};

	// generate an unlinked copy of `currFilter` for safe external usage
	me.cloneCurrentFilterObject = function() {
		return JSON.parse(JSON.stringify(currFilter));
	};

	// Logs interactions with the filter
	me.updateFilter = function(key, label, value, type) {
		var filterType = type || 'generic';

		// Log filter interactions to GA
		var eventAction;
		var eventLabel;
		if (type === 'generic') {
			if (key === 'hotelChainsFilter') {
				eventAction = 'Hotel Chain';
				eventLabel = 'Select ' + value + ' Chain';
			} else if (key === 'ecoFilter') {
				eventAction = 'Eco-certified';
				eventLabel = 'Select Eco-certified';
			} else if (key === 'sortFilter') {
				eventAction = 'Sort By';
				if (label === 'priceLowToHigh') {
					eventLabel = 'Price (Low to High)';
				} else if (label === 'priceHighToLow') {
					eventLabel = 'Price (High to Low)';
				} else if (label === 'alpha') {
					eventLabel = 'Alphabetic Order';
				} else if (label === 'distance') {
					eventLabel = 'Distance';
				}
			} 
		} else if (type == 'amenity') {
			eventAction = 'Amenities';
			eventLabel = label;
		} else if (type == 'promo') {
			eventAction = 'Promotions';
			eventLabel = label;
		} else {
			if (label === 'starCutoff') {
				eventAction = 'Star Rating';
				eventLabel = value.toString() + ' Stars';
			} else if (label === 'minRangePrice' || label === 'maxRangePrice') {
				eventAction = 'Your Budget - ' + (label === 'minRangePrice' ? 'Minimum' : 'Maximum');
				if(currFilter.hasOwnProperty(key)) {
					eventLabel = 'Adjust After Initial Search';
				} else {
					eventLabel = 'Adjust When Blank';
				}
			}
		}

		if (eventAction && eventLabel) {
			compass.GA.trackEvent('New Filters', eventAction, eventLabel);

			var isSplitView = settings.meetingInfo && settings.meetingInfo.showSideBySideGallery === true && 
				!$j('.mapOrGridWrapper').hasClass('full-map-view');
			
			if (isSplitView) {
				compass.GA.trackEvent('Split View', 'Filter Usage', eventAction + ' - ' + eventLabel);
			}
		}
		currFilter[key] = {key : label, value : value, type : filterType};
	};

	var updateFilterPromotions = function(key, type, value) {
		return function() {
			var check = $(this);
			var val = check.val();


			if (value == 'All Exclusive Promotions') {
				var promos = $('.promos').children('li');
				for (var i = 0; i < promos.length; i++) {

					var text = $(promos[i]).text();
					var filterKey = $(promos[i]).find('input').attr('class').split(/\s+/).map(function(promoClass) {if (promoClass != 'promoItem') return promoClass;});
					// first clear all previous selections as all exclusives filters by OR rather than AND
					if (me.find('input.' + filterKey[1]).val() != 'All Exclusive Promotions' && me.find('input.' + filterKey[1]).is(':checked')) {
						me.unsetFilter(filterKey[1], text, true, type);
					}
					// show all promotions as selected or unselected per All Exc Promos selection
					if (check.is(':checked')) {
						me.find('input.' + filterKey[1]).prop('checked', true);
						me.updateFilter(filterKey[1], text, true, type);
					} else {
						me.unsetFilter(filterKey[1], text, true, type);
					}
				}
			} else if (check.is(':checked')) {
				me.updateFilter(key, value || val, true, type);
			} else {
				// deselect All Exclusive Promotions if selected
				if (me.find(':input[value="All Exclusive Promotions"]').prop('checked')) {
					me.unsetFilter(me.find(':input[value="All Exclusive Promotions"]').attr('class').split(/\s+/)[1]);
				}
				me.unsetFilter(key);
			}
			me.dispatchChange();
			additionalFilters.trigger('SimplifiedHotelFilterAdditionalFilters.filterChangeHandler');

			me.updatePromoSelectText();
		};
	};

	var clearPromotionsCheckboxes = function() {
		var selectedPromoList = promoListElement.find("input:checked");
		for (var index = 0; index < selectedPromoList.length; ++index) {
			var item = selectedPromoList.eq(index);
			item.prop('checked', false);
			var key = item.attr('class').split(" ")[1];
			me.unsetFilter(key);
		}
	};

	// Hide promo options
	me.closeContainer = function() {
		relativePromotionsFilterContainer.css('visibility', 'hidden');
		me.find('.promotionsFilterDropdown').css('visibility', 'hidden');
		relativePromotionsFilterContainer.css('display', 'none');
		backerElement.css('visibility', 'hidden');
		me.dispatchChange(150);
	};

	// Show promo options
	me.openContainer = function() {
		if (me.filtersLocked) {
			return;
		}
		relativePromotionsFilterContainer.css('visibility', 'visible');
		me.find('.promotionsFilterDropdown').css('visibility', 'visible');
		relativePromotionsFilterContainer.css('display', 'block');
		backerElement.css('visibility', 'visible');
	};

	// Creates a function for triggered the 'filter changed' event across other widgets/elements
	me.dispatchChange = (function() {
		var timeout = null;
		function trigger() {
			me.trigger('HotelFilterWidget.dataChanged', currFilter);
			trackFirstUse();
			timeout = null;
		}
		return function(addDelay) {
			if(timeout != null) {
				window.clearTimeout(timeout);
			}
			var delay = settings.filterChangeDelay + (addDelay || 0);
			timeout = window.setTimeout(trigger, delay);
		};
	})();

	// Logs first interaction with the filter since page-load
	var trackFirstUse = _.once(function() {
		compass.trackEvent('FilterFirstUse');
	});

	/* Validate widget contents/settings */
	me.validate = function() {
		// TODO: either write this or remove this
		return true; 
	};


	/* Render the entire widget's contents */
	me.render = function(widgetElem) {
		var _labelId = compass.generateId();
		widgetElem.append(
			settings.displayAISearch && me.drawGalleryAI(),
			d.div({ className : 'categoryAndPriceSavingsWrapper' },
				me.drawCategory(),
				settings.showInventoryMatrix && me.drawNightlyAvailability(),
				settings.displayPriceSavings && me.drawPriceSavingsExplanation(),
				d.div({ className : 'clear' })
			),
			d.div(
				d.div({ className : 'datePickerFilterWrapper' },
					d.div({className: 'datePickerChainWrapper'},
						me.drawDatePicker(),
						me.drawHotelChainFilter(),
						settings.displayPromoFilter && me.drawPromotions(),
						me.drawEcoFilter(),
						me.drawClearAllFilters()
					),
					me.drawAdditionalFilters(),
					me.drawCheckInCheckOutWarning()
				),
				d.div({ className : 'sortByGalleryMapWrapper' },				
					me.drawSortBy(),
					me.drawViewControls()
				)
			),
			d.div({ className : 'clear' })
		);
		widgetElem.attr('ARIA-labelledby', _labelId);
		me.updateFilterLock(settings.meetingInfo.requireCheckInOutDates);
	};

	me.drawCheckInCheckOutWarning = function() {
		return d.div(
			{className:"checkInOutDatesWarning"},
			'Enter your check-in and check-out dates to see available hotels.'
		);
	};
	

	me.drawPriceSavingsExplanation = function() {
		var priceSavingsWrapper = d.div({className: 'priceSavingsExplanationLinkWrapper', tabindex: 0}, 
			d.div({className: 'priceSavingsIcon'}, d.i({className:'icon-usd fa-regular fa-usd'})),
			d.div({className: 'priceSavingsExplanationLink'}, "How rate comparison is calculated")
		);

		priceSavingsWrapper.activate(function() {
			compass.GA.trackEvent('New Filters', 'Rate Comparison Click');
			priceSavingsDialog = new compass.hotel.PriceSavingsExplanationWidget(null, {
				priceSavingsPercent: settings.meetingInfo.priceSavingsPercent
			});
		});
		return priceSavingsWrapper;
	};

	me.drawCategory = function() {
		return d.span({className : 'category'},
			'Category:&nbsp;',
			d.span({className: 'categoryName'}, settings.category)
		);
	};

	me.drawGalleryAI = function() {
		var defaultPlaceholder = 'Describe your ideal hotel and let our AI Smart Search find you a match';
		var errorPlaceholder = 'Please enter search criteria';
		var aiSubmitButton = d.button({ className: 'galleryAISubmit' }, '<i class="fas fa-sparkles"></i> Search');
		
		// Voice transcription widget container
		var voiceWidgetContainer = d.div({ className: 'galleryAIVoiceContainer' });
		var voiceTranscriptionWidget = new compass.hotel.VoiceTranscriptionWidget(voiceWidgetContainer, {
			WUID: 'VoiceTranscriptionWidget_galleryAI'
		});
		
		var aiInputErrorMessage = d.div({ className: 'galleryAIInputError' }, errorPlaceholder);

		function handleAISearch(isVoiceSearch) {
			var aiVal = $('.galleryAIInput').val().trim();
			if (!aiVal) {
				// Show error message, highlight input field, and change placeholder
				$('.galleryAIInput').val('');
				$('.galleryAIInput').addClass('error');
				$('.galleryAIInput').attr('placeholder', errorPlaceholder);
				$(aiInputErrorMessage).show();
				return false;
			}
			$('.galleryAIInput').removeClass('error');
			$('.galleryAIInput').attr('placeholder', defaultPlaceholder);
			$(aiInputErrorMessage).hide();
			$(aiDisclaimerMessage).show();
			
			compass.loading.start();
			$('.galleryAISubmit').prop('disabled', true);
			$('.galleryAIInput').prop('disabled', true);
			
			// Clear any previous error messages
			$('.aiSearchError').hide();
			
			jQuery.ajax({
					url: '/galleryAI',
					type: 'POST',
					data: JSON.stringify({
							prompt: aiVal,
							arrive: me.arrive,
							depart: me.depart,
							voice_search: isVoiceSearch || false
					}),
					dataType: 'json',
					success: function(data) {
						if (!data.success) {
								$('.galleryAI .aiSearchError').show();
								
								// Clear any existing AI search filters
								me.unsetFilter('aiSearch');
								return;
						}
						
						me.updateFilter('aiSearch', 'aiSearch', data.hotel_ids, 'aiSearch');
						clearAllFiltersButton.removeClass('disabled');
						me.dispatchChange();
					},
					error: function(xhr, status, error) {
							// Show the pre-defined error message
							$('.galleryAI .aiSearchError').show();
							
							// Clear any existing AI search filters
							me.unsetFilter('aiSearch');
					},
					complete: function(data) {
							$('.galleryAISubmit').prop('disabled', false);
							$('.galleryAIInput').prop('disabled', false);
							compass.loading.stop();
					},
			});
		}

		aiSubmitButton.activate(function() {
			handleAISearch(false);
		});
	
		var aiInput = d.input({
			className: 'galleryAIInput',
			placeholder: defaultPlaceholder,
			maxlength: 250
		});

		$(aiInput).on('input', function() {
			$('.galleryAIInput').removeClass('error');
			$('.galleryAIInput').attr('placeholder', defaultPlaceholder);
			$(aiInputErrorMessage).hide();
		});

		$(aiInput).on('focus', function() {
			$('.galleryAIInput').removeClass('error');
			$('.galleryAIInput').attr('placeholder', defaultPlaceholder);
			$(aiInputErrorMessage).hide();
		});

		$(aiInput).keyup(function(e) {
			if (e.target.value.length === 0 && currFilter.hasOwnProperty('aiSearch')) {
				$('.galleryAIDisclaimer').hide();
				$('.aiSearchError').hide();
				me.unsetFilter('aiSearch');
				me.dispatchChange();
			}
			if (e.which === 13) {
				handleAISearch(false);
				return false;
			}
		});
	
		var aiTooltip = d.div({ className: 'galleryAITooltip' }, 
			'Select your check-in and check-out dates, then describe your ideal hotel, including details like hotel chain, amenities, and more.',
			d.br(),
			d.br(),
			'Please avoid personal or inappropriate content.'
		);
		
		var aiDisclaimerMessage = d.div({ className: 'galleryAIDisclaimer' }, 
			'While we strive to provide accurate and relevant results, please note that the AI may occasionally produce errors or omissions. We recommend verifying the details of your selected hotel before making any reservations.'
		);

		var aiTooltipIconWrapper = d.div({ className: 'galleryAITooltipIconWrapper' },
			d.i({ className: 'icon-info-sign fa-solid fa-circle-info galleryAITooltipIcon' })
		);
	
		var aiTooltipIconPreText = d.div({ className: 'galleryAITooltipIconPreText'},
			'Let our new <strong>AI Smart Search</strong> find your preferred hotel, and use the filters below to refine your search.',
			aiTooltipIconWrapper
		);
	
		var iconTooltipWrapper = d.div({ className: 'aiIconTooltipWrapper' }, aiTooltipIconPreText, aiTooltip);
		var aiErrorElement = d.div({ className: 'aiSearchError' },
			d.i({ className: 'fas fa-exclamation-triangle' }),
			' Oops! There has been an error with your search. Please try again.'
		);
		
		var voiceErrorElement = d.div({ className: 'voiceTranscriptionError' },
			d.i({ className: 'fas fa-microphone-slash' }),
			' Microphone error: Please check your browser permissions.'
		);
		
		var characterLimitWarningElement = d.div({ className: 'galleryAICharacterLimitWarning' },
			d.i({ className: 'fas fa-exclamation-triangle' }),
			'Voice input was truncated to 250 characters.'
		);

		voiceTranscriptionWidget.bind('VoiceTranscriptionWidget.transcriptionComplete', function(evt, transcriptionText) {
			var maxLength = 250;
			var isOverLimit = transcriptionText.length > maxLength;
			
			if (isOverLimit) {
				// Truncate to max length
				transcriptionText = transcriptionText.substring(0, maxLength);
				// Show warning message
				$(characterLimitWarningElement).show();
				// Auto-hide warning after 5 seconds
				setTimeout(function() {
					$(characterLimitWarningElement).hide();
				}, 5000);
			}
			
			$(aiInput).val(transcriptionText);
			if (transcriptionText.trim()) {
				$(aiDisclaimerMessage).show();
				handleAISearch(true);
				clearAllFiltersButton.removeClass('disabled');
			}
		});
		
		voiceTranscriptionWidget.bind('VoiceTranscriptionWidget.error', function(evt, errorMessage) {
			$(voiceErrorElement).html('<i class="fas fa-microphone-slash"></i> ' + errorMessage);
			$(voiceErrorElement).show();
			setTimeout(function() {
				$(voiceErrorElement).hide();
			}, 5000);
		});

		var container = d.div({ className: 'galleryAI' },
			iconTooltipWrapper,
			d.div({ className: 'galleryAIWrapper' }, 
				aiInput, 
				voiceWidgetContainer, 
				aiSubmitButton
			),
			aiDisclaimerMessage,
			aiErrorElement,
			voiceErrorElement,
			characterLimitWarningElement
		);

		aiTooltipIconWrapper.attr('tabindex', '0');
		aiTooltipIconWrapper.click(function() {
			aiTooltip.toggleClass('show');
			if (aiTooltip.hasClass('show')) {
				aiTooltipIconWrapper.focus();
			}
		});

		aiTooltipIconWrapper.on('blur', function() {
			aiTooltip.removeClass('show');
		});
	
		return container;
	};
	
	me.drawSortBy = function() {
		var filterArray = [
			{ label: 'Alphabetical Order', value:'alpha' },
			{ label: 'Distance', value:'distance' },
			{ label: 'Price (low to high)', value:'priceLowToHigh' },
			{ label: 'Price (high to low)', value:'priceHighToLow' }
		];
		
		var filterDropdown = d.dataSelect({
			data : filterArray,
			initialSelection : settings.defaultSortDistance ?  _.findIndex(filterArray, function(filter){return filter.value === 'distance';}) : 0,
			className : 'filterDropdown',
			change : function (selected) {
				var options = $(filterDropdown).find(".dataSelectItem");
				for (var index = 0; index < options.length; index++) {
					var option = options[index];
					$(option).removeClass('selected');
					if (selected.label === option.innerText) {
						$(option).addClass('selected');
					}
				}
				me.updateFilter('sortFilter', selected.value, 1, 'generic');
				me.dispatchChange();
			},
			labelMapper : function(data) { return data.label; },
			choiceMapper: function(data) { return data.label; },
			classMapper : function(data) { 
				return data.value + ((settings.defaultSortDistance && data.value === 'distance') || (!settings.defaultSortDistance && data.value === 'alpha') ? ' selected' : ''); 
			},
			preHandleClick : function() {
				// dataSelect automatically resets its style properties, but we need to override that.
				// use a short timeout & hide the element until we can adjust it how we want
				var optionWrapper = $('.dataSelectContent');
				optionWrapper.css('visibility', 'hidden');
				if (me.filtersLocked) {
					return;
				}
				setTimeout(function() {
					optionWrapper.css('visibility', 'visible');
					optionWrapper.css('top', '-30px');
					var selectedOption = filterDropdown.find('.selected');
					if (selectedOption.length > 0) {
						selectedOption.focus();
					} else {
						filterDropdown.find('.dataSelectItem').eq(0).focus();
					}
					// prevent element running off page
					var dropdown_position_data = $('.filterDropdown')[0].getBoundingClientRect();
					var options_width = parseInt(optionWrapper.css('width'), 10);
					var page_overflow = Math.min(0, -25 + window.innerWidth - dropdown_position_data.x - options_width);
					optionWrapper.css('left', Math.ceil(page_overflow) + 'px');
				}, 1);
			},
			idGenerator	: compass.generateId
		});
		me.updateFilter('sortFilter', settings.defaultSortDistance ? 'distance' : 'alpha', 1, 'generic');
		return [d.div({className : 'sortByFilter'}, d.span({className : 'filterDropdownLabel'}, 'Sort By:'), filterDropdown), d.div({ className : 'clear' })];
	};

	me.drawViewControls = function() {
		if (!settings.meetingInfo.showSideBySideGallery || settings.forceTraditionalToggle) {
			var gridButton = d.div({
				className : 'gridview filterView roundedContainer selected',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-label' : 'Display as Gallery',
				tabindex : 0
			},
				d.span({ className : 'filterLabel' }, 'Gallery'),
				d.div({className: 'gridIcon'}, d.i({className:'fa-regular fa-grid'}))
			);
			
			var mapButton = d.div({
				className : 'mapview filterView roundedContainer',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-label' : 'Display on Map',
				tabindex : 0
			},
				d.span({ className : 'filterLabel' }, 'Map'),
				d.div({className: 'mapIcon'}, d.i({className:'fa-regular fa-map-location-dot'}))
			);

			gridButton.activate(function() {
				if (me.filtersLocked) {
					return;
				}
				compass.GA.trackEvent('Gallery View', 'Toggle View', 'Gallery View');
				me.trigger('HotelFilterWidget.gridViewClicked');
				$(mapButton).toggleClass('selected', false);
				$(gridButton).toggleClass('selected', true);
			});
			
			mapButton.activate(function() {
				if (me.filtersLocked) {
					return;
				}
				compass.GA.trackEvent('Map View', 'Toggle View', 'Map View');
				me.trigger('HotelFilterWidget.mapViewClicked');
				$(mapButton).toggleClass('selected', true);
				$(gridButton).toggleClass('selected', false);
			});

			return d.div({className : 'viewControls', 'ARIA-label' : 'Results Display Options'}, 
				gridButton, mapButton
			);
		} else {
			// Add Show/Hide Map button when split view is enabled
			var isMapVisible = true;
			
			var showHideMapButton = d.div({
				className : 'roundedContainer show-hide-map-button',
				role : 'button',
				'ARIA-role' : 'button',
				'ARIA-label' : 'Hide Map',
				tabindex : 0,
				title : 'Hide Map'
			},
				d.span({ className : 'filter-label' }, 'Hide Map'),
				d.i({className:'fa-regular fa-eye-slash'})
			);

			showHideMapButton.activate(function() {
				if (me.filtersLocked) {
					return;
				}
				
				isMapVisible = !isMapVisible;
				
				if (isMapVisible) {
					$(showHideMapButton).find('.filter-label').text('Hide Map');
					$(showHideMapButton).find('i').toggleClass('fa-map-location-dot', false).toggleClass('fa-eye-slash', true);
					$(showHideMapButton).attr('aria-label', 'Hide Map').attr('title', 'Hide Map');
					compass.GA.trackEvent('Split View', 'Toggle View', 'Split View');
					me.trigger('HotelFilterWidget.showMapClicked');
				} else {
					$(showHideMapButton).find('.filter-label').text('Show Map');
					$(showHideMapButton).find('i').toggleClass('fa-eye-slash', false).toggleClass('fa-map-location-dot', true);
					$(showHideMapButton).attr('aria-label', 'Show Map').attr('title', 'Show Map');
					compass.GA.trackEvent('Gallery View', 'Toggle View', 'Gallery View');
					me.trigger('HotelFilterWidget.hideMapClicked');
				}
			});

			return d.div({className : 'viewControls', 'ARIA-label' : 'Map Display Options'}, 
				showHideMapButton
			);
		}
	};
	
	// Method to update view controls dynamically (for mobile/desktop transitions)
	me.updateViewControls = function(forceTraditionalToggle) {
		var viewControlsContainer = me.find('.viewControls');
		if (viewControlsContainer.length > 0) {
			var originalForceTraditionalToggle = settings.forceTraditionalToggle;
			settings.forceTraditionalToggle = forceTraditionalToggle;

			var newViewControls = me.drawViewControls();
			viewControlsContainer.replaceWith(newViewControls);

			settings.forceTraditionalToggle = originalForceTraditionalToggle;
		}
	};
	
	me.drawNightlyAvailability = function() {
		var nightlyAvailWrapper = d.div({className: 'nightlyAvailabilityWrapper', tabindex: 0}, 
			d.div({className: 'nightlyAvailabilityIcon'}, d.i({className:'fa-regular fa-calendar-check'})),
			d.div({className: 'nightlyAvailabilityLink'}, "View Nightly Availability")
		);
		nightlyAvailWrapper.activate(function() {
			compass.GA.trackEvent('New Filters', 'View Nightly Availability', 'Nightly Availability');
			me.trigger('HotelFilterWidget.showNightlyAvailabilityPopup');
		});
		return nightlyAvailWrapper;
	};
	
	me.drawHotelChainFilter = function() {
		var hotelChains = _.chain(settings.hotels)
					.filter(function(hotel) { return hotel.hotelChain ? true : false; })
					.map(function(hotel) { return { value : hotel.hotelChain, id : hotel.hotelChainId }; })
					.uniq(function(hotel) { return hotel.value; })
					.sortBy(function(hotel) { return hotel.value; })
					.value();

		if (hotelChains.length === 0) { return; }

		var initialIndex = _.findIndex(hotelChains, function(chain) {
			return chain.id.toString() === settings.initialFilters.chain_id;
		});
		var defaultBlank = initialIndex === -1 ? true : false;

		var filterDropdown = d.dataSelect({
			data : hotelChains,
			className : 'hotelChainFilterDropdown',
			change : function (selected) {
				var options = filterDropdown.find(".dataSelectItem");
				for (var index = 0; index < options.length; index++) {
					var option = options[index];
					$(option).removeClass('selected');
					if (selected.value === option.innerText) {
						$(option).addClass('selected');
					}
				}
				clearAllFiltersButton.removeClass('disabled');
				additionalFilters.trigger('SimplifiedHotelFilterAdditionalFilters.setChainFilterActive', true);
				me.updateFilter('hotelChainsFilter', 'hotelChain', selected.value, 'generic');
				me.dispatchChange();
			},
			defaultBlank: defaultBlank,
			initialSelection: Math.max(0, initialIndex),
			labelMapper : function(data) {
				return d.span({className: 'selectedValue'}, data.value);
			},
			choiceMapper: function(data) { return data.value; },
			preHandleClick : function() {
				// dataSelect automatically resets its style properties, but we need to override that.
				// use a short timeout & hide the element until we can adjust it how we want
				var optionWrapper = me.find('.hotelChainFilterDropdown .dataSelectContent');
				optionWrapper.css('visibility', 'hidden');
				if (me.filtersLocked) {
					return;
				}
				setTimeout(function() {
					var dropdown_position_data = me.find('.hotelChainFilter')[0].getBoundingClientRect();
					var dropdown_label_position_data = me.find('.hotelChainFilterLabel')[0].getBoundingClientRect();
					optionWrapper.css('visibility', 'visible');
					optionWrapper.css('top', '30px');
					var selectedOption = filterDropdown.find('.selected');
					if (selectedOption.length > 0) {
						selectedOption.focus();
					} else {
						filterDropdown.find('.dataSelectItem').eq(0).focus();
					}
					optionWrapper.css('width', Math.ceil(dropdown_position_data.width) + 'px');
					optionWrapper.css('left', (-Math.ceil(dropdown_label_position_data.width) - 6) + 'px');
				}, 1);
			},
			idGenerator	: compass.generateId
		});
		if (defaultBlank) {
			filterDropdown.find('.dataSelectInputLabel').text('Select a Hotel Chain');
		}

		if (initialIndex !== -1) {
			me.updateFilter('hotelChainsFilter', 'hotelChain', hotelChains[initialIndex].value, 'generic');
			me.dispatchChange();
			startWithClearButtonActive = true;
		}

		return d.div({className : 'hotelChainFilterWrapper'},
			d.div({className : 'hotelChainFilter roundedContainer'},
				d.span({className : 'hotelChainFilterLabel'}, 'Hotel Chain <i class="hotelChainIcon fa-solid fa-hotel">'),
				filterDropdown
			)
		);
	};

	// Promo Filter
	me.drawPromos = function() {
		promoListElement = d.div(
			{className: 'promotionsListWrapper'},
			d.div({className : 'promoHelperText'},
				'Discover exclusive promotions offered only when booking with onPeak.',
				d.hr()
			),
			d.ul(
				{className : 'promos'},
				$.map(['All Exclusive Promotions', ...promotions.slice(1).sort()], function(elem, index) {
					var key = me.generateFilterKey();
					var labelId = compass.generateId();
					return d.li(
						{className : 'promo'},
						d.label(
							{'for': labelId, tabindex: 0},
							d.div({className : 'pseudoPromoCheckbox ' + key},
								d.input({
									className : 'promoItem ' + key,
									type : 'checkbox',
									value : elem,
									'ARIA-labelledby' : labelId,
									id: labelId,
									tabindex: -1
								}).change(updateFilterPromotions(key, 'promo', elem)),
								d.div({className : 'pseudoPromoCheckmark'}),
								d.span({id: labelId}, elem)
							)
						).bind('keydown', function(e) {
							if (e.keyCode === 13 || e.keyCode == 32) {
								$(this).find('input').trigger('click');
								return false;
							}
						})
					);
				})
			)
		);
		return [backerElement, promoListElement, d.div({className : 'clear'})];
	};

	// determine selected promos for promotionsDropdown text
	me.updatePromoSelectText = function() {
		selectedPromos = Object.values(currFilter).filter(function(item) {return item.type == 'promo';});
		var primarySelectedPromo;
		if (selectedPromos[0] && selectedPromos[0].key) {
			primarySelectedPromo = selectedPromos[0].key;
		}
		var additionalSelectedPromos = selectedPromos.length-1;
		if (selectedPromos.length > 1) {
			selectedPromoText = primarySelectedPromo + ' +' + additionalSelectedPromos;
		} else {
			selectedPromoText = primarySelectedPromo;
		}

		if (selectedPromos.map(function(promo) {return promo.key;}).includes('All Exclusive Promotions')) {
			me.find('.promotionsDropdown').addClass('selectedValue');
			me.find('.promotionsDropdown').removeClass('dataSelectInputLabel');
			me.find('.promotionsDropdown').text('All Exclusive Promotions');
		} else if (!selectedPromoText || selectedPromoText == 'undefined' || selectedPromoText == 'Select Promotions') {
			me.find('.promotionsDropdown').removeClass('selectedValue');
			me.find('.promotionsDropdown').text('Select Promotions');
			me.find('.promotionsDropdown').addClass('dataSelectInputLabel');
		} else {
			me.find('.promotionsDropdown').addClass('selectedValue');
			me.find('.promotionsDropdown').removeClass('dataSelectInputLabel');
			me.find('.promotionsDropdown').text(selectedPromoText);
		}
	};

	me.drawPromotions = function() {
		if (promotions.length <= 1) { return; }
		var promoText = selectedPromoText || 'Select Promotions';

		relativePromotionsFilterContainer = d.div({className : 'relativePromotionsFilterContainer', style: {visibility: 'hidden'}},
			d.div({className: 'promotionsFilterDropdown roundedContainer'},
				me.drawPromos()
			)
		);
		backerElement = d.div({className:'promosFilterBacker'});
		backerElement.click(me.closeContainer);
		return [backerElement, d.div({className : 'promotionsFilterWrapper'},
			d.div({className : 'promotionsFilter roundedContainer'},
				d.span({className : 'promotionsFilterLabel'}, 'Promotions <i class="fa-sharp fa-solid fa-award"/>'),
				d.span({className: 'promotionsDropdown dataSelect dataSelectInput dataSelectInputLabel', tabindex: 0}, promoText)
					.activate(function() {
						if (relativePromotionsFilterContainer.css('visibility') != 'visible') {
							me.openContainer();
							relativePromotionsFilterContainer.css('position', 'relative');
						} else {
							me.closeContainer();
						}
					})
			),
			relativePromotionsFilterContainer
		)];
	};

	// Eco Certification Filter
	me.drawEcoFilter = function() {
		// Do not show Eco Certification filter if none of the meeting hotels are certified
		if (settings.hotels.filter(h => h.isEcoCertified).length === 0) {
			return;
		}
		var helperDialog = d.div(
			{className: 'ecoFilterHelperText', style: {visibility: 'hidden', width: '1px'}},
			'Click to filter by hotels with sustainability certifications or awards (determined by a third party)'
		);
		var button = d.div(
			{
				className: 'ecoFilterButton roundedContainer',
				role: 'button',
				'ARIA-role': 'button',
				'ARIA-label': 'Toggle eco-certification filter',
				tabindex: 0
			},
			'Eco-certified',
			d.i({className:'filterIcon fa-regular fa-leaf'})
		);
		button.click(function(evt) {
			let ecoFilterActive = false;
			let buttonRef = $(button);
			buttonRef.removeClass('selected');
			buttonRef.find('.filterIcon').removeClass('fa-solid fa-regular');
			if (currFilter.hasOwnProperty('ecoFilter')) {
				me.unsetFilter('ecoFilter');
				buttonRef.find('.filterIcon').addClass('fa-regular');
			} else {
				me.updateFilter('ecoFilter', 'ecoCertified', null, 'generic');
				buttonRef.addClass('selected');
				buttonRef.find('.filterIcon').addClass('fa-solid');
				ecoFilterActive = true;
			}
			additionalFilters.trigger('SimplifiedHotelFilterAdditionalFilters.setEcoFilterActive', ecoFilterActive);
			me.dispatchChange();
		});
		button.mouseover(function(evt) {
			let helperDialogRef = $(helperDialog);
			helperDialogRef.width(helperDialogRef.css('max-width'));
			// if message would go off-screen, resize to keep on-screen
			$(helperDialog).removeClass('wrapped');
			let clipAmount = Math.round($(window).width() - (helperDialogRef.offset().left + parseInt(helperDialogRef.css('max-width'))));
			const clipMargin = 40;
			const clipThreshold = 80;
			if (clipAmount <= clipMargin) {
				// If message is going to be consideriably squished by adjustment, anchor it to left side & recalculate the new width
				if (clipAmount <= (clipMargin - clipThreshold)) {
					$(helperDialog).addClass('wrapped');
					clipAmount = Math.round($(window).width() - (helperDialogRef.offset().left + parseInt(helperDialogRef.css('max-width'))));
				}
				clipAmount -= clipMargin;
				helperDialogRef.width(`${parseInt(helperDialogRef.css('max-width')) + clipAmount}px`);
			}
			$(helperDialog).css('visibility', '');
		});
		button.mouseout(function(evt) {
			$(helperDialog).width(1);
			$(helperDialog).css('visibility', 'hidden');
		});
		var ecoCertificationContainer = d.div({className: 'ecoFilterWrapper'}, button, helperDialog);
		return ecoCertificationContainer;
	};

	me.drawClearAllFilters = function() {
		clearAllFiltersButton = d.button({className: 'resetFilterClearButton'}, 'Clear All Filters');
		if (!startWithClearButtonActive) {
			clearAllFiltersButton.addClass('disabled');
		}

		clearAllFiltersButton.click(function() {
			me.resetFilter();
			me.updatePromoSelectText();
			additionalFilters.clearFilters();
			$('.additionalFilterButton').focus();
			compass.GA.trackEvent('New Filters', 'Clear All Filters', 'Clear Outside Menu');
		});
		me.bind("SimplifiedHotelFilterWidget.clearButton", function() {
			me.resetFilter();
		});

		me.bind("SimplifiedHotelFilterWidget.setClearButtonVisible", function(event,eventData) {
			if (eventData === true) {
				clearAllFiltersButton.removeClass('disabled');
			} else {
				clearAllFiltersButton.addClass('disabled');
			}
		});

		return clearAllFiltersButton;
	};

	me.resetFilter = function() {
		// Clear AI Gallery input
		me.find('.galleryAIInput').val('');
		me.find('.galleryAIDisclaimer').hide();
		
		me.unsetFilter('hotelChainsFilter');
		me.find('.hotelChainFilterDropdown').trigger('clear');
		me.find('.hotelChainFilterDropdown .dataSelectInputLabel').text('Select a Hotel Chain');
		me.find('.resetFilterClearButton').addClass('disabled');
		me.find('.hotelChainFilter .dataSelectItem.selected').removeClass('selected');
		if (settings.displayPromoFilter && promotions.length > 1) {
			clearPromotionsCheckboxes();
		}
		me.find('.ecoFilterButton').removeClass('selected');
		me.find('.ecoFilterButton .filterIcon').removeClass('fa-solid').addClass('fa-regular');
		additionalFilters.trigger('SimplifiedHotelFilterAdditionalFilters.setChainFilterActive', false);
		additionalFilters.trigger('SimplifiedHotelFilterAdditionalFilters.setEcoFilterActive', false);
		// clear any remaining non-sort filters
		for (var filterKey in currFilter) {
			if (filterKey != 'sortFilter') delete currFilter[filterKey];
		}
	};

	me.drawDatePicker = function() {
		var wrapper = d.div({className : 'SimplifiedHotelFilterDatePickerWrapper'}, '');
		datePicker = new compass.hotel.SimplifiedHotelFilterDatePicker(wrapper, {
			mainFilterWidget : me,
			meetingInfo : settings.meetingInfo,
			dateFormat : settings.dateFormat,
			defaultFilterDatesToBlank : settings.defaultFilterDatesToBlank,
			nightsArray : settings.nightsArray
		});
		return wrapper;
	};

	me.handleUpdatePreviousFilterObjects = function(previous) {
		previousFilterObjects = previous;
		return previousFilterObjects;
	};

	me.drawAdditionalFilters = function() {
		var maxRooms = _.chain(settings.hotels)
			.map(function(hotel) {
				return hotel.avail.status === 'NORMAL' ? hotel.avail.maxMultiBlockReservations : 1;
			})
			.max()
			.value();

		var wrapper = d.div({className : 'SimplifiedHotelFilterAdditionalFiltersWrapper'}, '');
		additionalFilters = new compass.hotel.SimplifiedHotelFilterAdditionalFilters(wrapper, {
			mainFilterWidget : me,
			displayHotelStars : settings.displayHotelStars,
			currencySymbol : compass.util.getCurrencySymbolFromCode(settings.meetingInfo.currencyCode),
			maxRooms: maxRooms,
			previousFilterObjects: previousFilterObjects,
			promotions: promotions
		});
		return wrapper;
	};

}, {
	WUID : 'SimplifiedHotelFilterWidget',
	widgetName : 'SimplifiedHotelFilterWidget',
	meetingInfo : {"minCheckIn" : "04/27/2012", "maxCheckIn" : "05/03/2012", "minCheckOut" : "04/28/2012",  "maxCheckOut" : "05/04/2012",  "starts": "04/29/2012", "ends": "05/01/2012", "requireCheckInOutDates": false },
	category : '',
	hotels : [],
	displayHotelStars : true,
	displayPriceSavings: false,
	showInventoryMatrix: false,
	dateFormat : 'MM/DD/YYYY',
	defaultFilterDatesToBlank : false,
	nightsArray : [],
	filterChangeDelay : 200,
	defaultSortDistance: false,
	initialFilters: {},
	displayAISearch: false
});
